import {
    createOrUpdateSubContractPrint,
} from "@/services/allContractServices";
export const mixins = {
    props: {
        dialogForm: {
            type: Object,
        },
        subServiceContractId: {
            type: Number,
            default: null,
        },
        templateKey: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            printClass: '',
            loading: false,
        };
    },
    watch: {
        dialogForm: {
            handler(newName, oldName) {
                if (!this.saveflag && !newName.subContractPrintVO.content) {
                    this.detailForm = { ...this.detailForm, ...newName };
                }
            },
            deep: true,
        },
        // subServiceContractId: {
        //     handler(newName, oldName) {
        //         this.saveflag = false;
        //         this.printClass = this.dialogForm.serialNumber + this.templateKey;
        //         this.getsubServiceContractDetail(this.subServiceContractId);
        //     },
        // },
        templateKey: {
            handler(newName, oldName) {
                this.printClass = this.dialogForm.serialNumber + this.templateKey;
                if (this.subServiceContractId)
                {
                    this.loading = true;
                    this.getsubServiceContractDetail(this.subServiceContractId);
                }
                    
            },
        }
    },

    created() { },

    mounted() {
        if (this.subServiceContractId) {
            this.loading = true;
            this.getsubServiceContractDetail(this.subServiceContractId);
        }
        if (!this.dialogForm.subContractPrintVO.content)
            this.detailForm = { ...this.detailForm, ...this.dialogForm };
        this.printClass = this.dialogForm.serialNumber + this.templateKey;

        // genWaterMark({
        //     className: 'HTMLLaborContract1',
        //     content: "水印你要显示的内容",
        //     font: '22px Microsoft YaHei', // 字体
        //     color: 'rgba(156, 162, 169, 0.2)', // 颜色
        //     rotate: -35,  // 偏转角度
        //     position: 'absolute',
        //   });

        // this.laborContractContent = this.$refs.HTMLLaborContract.innerHTML;
        // this.laborContractContent =
        //   document.getElementById("HTMLLaborContract").innerHTML;
    },

    methods: {
        //保存当前合同
        saveContractApi(param) {
            createOrUpdateSubContractPrint(param)
                .then((res) => {
                    if (res.code == 10000000) {
                        this.$alert("合同模板保存成功", "提示", {
                            confirmButtonText: "确定",
                        });
                    } else {
                        this.$alert(res.msg, "确定");
                    }
                })
                .catch((err) => {
                    this.$message.error("网络请求失败");
                });
        },
        saveCommon(type) {
            if (this.detailForm.approveStatus == 2) {
                this.$alert("合同为待审核无法修改", "提示", {
                    confirmButtonText: "确定",
                });
                return;
            }
            this.getValues();
            this.detailForm.subContractSignVO && (delete this.detailForm.subContractSignVO)
            this.detailForm.contractScanVOs && (delete this.detailForm.contractScanVOs)
            this.detailForm.contractItemVOs && (delete this.detailForm.contractItemVOs)
            this.detailForm.conferenceItemVOs && (delete this.detailForm.conferenceItemVOs)
            this.detailForm.subContractMaterialDetailsVOs && (delete this.detailForm.subContractMaterialDetailsVOs)
            this.detailForm.subContractQuotaDetailsVOs && (delete this.detailForm.subContractQuotaDetailsVOs)
            this.detailForm.subContractUnionDetailsVOList && (delete this.detailForm.subContractUnionDetailsVOList)
            this.detailForm.subContractPrintVO && (delete this.detailForm.subContractPrintVO)
            this.detailForm.appendSubContracts && (delete this.detailForm.appendSubContracts)
            this.detailForm.pointSettingDto && (delete this.detailForm.pointSettingDto)
            this.detailForm.contractPeriodArr && (delete this.detailForm.contractPeriodArr)

            let param = {
                content: JSON.stringify(this.detailForm),
                // subContractId:this.subServiceContractId,
                version: "1.0",
                flag: 1,
            };
            this.saveflag = true;
            this.$emit("savePrintInfo", param);
            if (this.subServiceContractId) {
                param.subContractId = this.subServiceContractId;
                param.templateType =
                    this.dialogForm.subContractPrintVO?.templateType ?? type;
                this.saveContractApi(param);
            } else {
                this.$message.success("保存成功");
            }

        }
    }

};